export const statuses = [
    { value: 'new', displayValue: "New" },
    { value: 'scheduled', displayValue: "Scheduled" },
    { value: 'inWarehouse', displayValue: "In Warehouse" },
    { value: 'onHold', displayValue: "On Hold" },
    { value: 'finished', displayValue: "Finished" },
];
export const types = [{ value: 'pickup', displayValue: 'Pickup' }, { value: 'delivery', displayValue: 'Delivery' }]